import {
  globalMessageHandler,
  GridModalFormProps,
  useForm,
  UseFormReturnType,
  Validator,
} from "common";
import { useParams } from "common/components/Form/ParamsContext";
import I18n from "i18n";
import { Params } from "react-router-dom";
import {
  EmailTemplateItem,
  EmailTemplateOptions,
  getEmailTemplateService,
} from "./emailTemplateApi";

export interface UseEmailTemplateFormProps extends GridModalFormProps {}

type RouteParams = {
  email_template_id?: string;
};

export interface UseEmailTemplateFormReturnType extends UseFormReturnType<
  EmailTemplateItem,
  EmailTemplateOptions
> {
  params?: Readonly<Params<"email_template_id">>;
}

export default function useEmailTemplateForm({
  id,
  afterSave,
  defaultValues,
}: UseEmailTemplateFormProps): UseEmailTemplateFormReturnType {
  const params = useParams<"email_template_id">();
  const scope = undefined;
  const service = getEmailTemplateService(scope);

  const form = useForm<EmailTemplateItem, EmailTemplateOptions>({
    id: params.email_template_id || id,
    ignoreNavigateAfterCreate: true,
    translationCategory: "EmailTemplate",
    rules: {
      name: Validator.rule.string().required(),
      subject: Validator.rule.string().required(),
      body: Validator.rule.string().required(),
    },
    afterSave,
    defaultValues,
    onValidationFailed: () => {
      globalMessageHandler.snack({
        severity: "error",
        message: I18n.t("App.formHasErrors"),
      });
    },
    ...service,
    loadOptions: undefined,
  });

  return { ...form, params };
}
